import React from 'react';
import { Typography, Flex, Card } from 'antd';
import Icon from '@mdi/react';
import Ninja from '@ninja';

const { Title } = Typography;

const CrmInfoSection = ({ title, icon, children }) => {
  return (
    <div style={{ marginBottom: 24 }}>
      <Flex align='center' gap='small' style={{ marginBottom: 16 }}>
        {icon && <Icon path={icon} size={0.7} color={Ninja.colors.medium} />}
        <Title level={5} className='!text-color-medium !font-medium !m-0'>
          {title}
        </Title>
      </Flex>
      <Card size='small' style={{ background: '#fafafa' }}>
        {children}
      </Card>
    </div>
  );
};

export default CrmInfoSection;
